import http from '@/biz/http.mjs'
import {Alert, Confirm, useOpenModal} from '@/components/Modal/index.mjs'
import runAsync from '@/script/runAsync.mjs'
import parseMap from '../../scripts/parseMap.mjs'

const useIntegrate = () => {
    const openModal = useOpenModal()

    return async (map, type) => {
        await map.commands.saveMap()
        const {prjId, sVer} = map.data
        const bizNodeType = type.toUpperCase()

        const errorNodes = await runAsync(
            () => http.get('/autoIntegrateCheck', {bizNodeType, prjId, sVer}),
            {action: '自动集成检查'}
        )

        if (0 < errorNodes.length) {
            const names = errorNodes
                .map(e => e.name)
                .join('、')

            if ('Sa' === type) {
                const isConfirmed = await openModal(
                    <Confirm>
                        当前还有{names}未发布，确定是否继续集成？（系统仅对发布状态结构对应的模型进行集成）
                    </Confirm>
                )

                if (! isConfirmed) {
                    return
                }
            }
            else {
                await openModal(
                    <Alert type="error">
                        {names}还未发布，请发布后再进行集成！
                    </Alert>
                )

                return
            }
        }

        const {mapModel} = await runAsync(
            () => http.post(`/autoIntegrate${type}`, {prjId, sVer}),
            {action: '自动集成'}
        )

        const {root} = parseMap(mapModel)
        const _n = map.nodeProxy(map.root)
        map.execute(() => _n.replace(root))
    }
}

export const integrate = () => () => {
    const integrate = useIntegrate()

    return async function (type) {
        await integrate(this, type)
    }
}
